import { createSlice } from "@reduxjs/toolkit";

export const tokenSlice = createSlice({
  name: "token",
  initialState: null,
  reducers: {
    set: (state, action) => {
      return action.payload;
    },
    remove: (state, action) => {
      return null;
    },
  },
});

export default tokenSlice;
